import axiosInstance from "@/api/axiosInstance";

export interface RetrySageTransactionSyncResponse {
  data: {
    syncStatus: string;
    syncError?: string | null;
    invoiceNumber?: string | null;
  };
}

export async function retrySageTransactionSync(
  sageTransactionId: number,
): Promise<RetrySageTransactionSyncResponse> {
  const response = await axiosInstance.post<RetrySageTransactionSyncResponse>(
    `/api/private/sage-transactions/${sageTransactionId}/retry-sync`,
  );
  return response.data;
}
